import DOMPurify from "isomorphic-dompurify"
import React, { useState } from "react"
import styles from "@/components/Shared/index.module.scss"
import { removeAndCleanLinkConcat, getAnalyticLinkUrl } from "@/utils/helper"

const MainFooter = props => {
  const { data, columnClassNames, isOmnichannel } = props
  const [gbhExpand, setGbhExpand] = useState([])

  const handleGbhExpand = key => {
    if (!gbhExpand.includes(key)) {
      const newGbhExpand = [...gbhExpand]
      newGbhExpand.push(key)
      setGbhExpand(newGbhExpand)
    } else {
      const newGbhExpand = [...gbhExpand]
      const idx = gbhExpand.indexOf(key)
      newGbhExpand.splice(idx, 1)
      setGbhExpand(newGbhExpand)
    }
  }

  return (
    <div
      className={`${columnClassNames ? columnClassNames : ""} ${
        styles.mainFooterWrapper
      } ${isOmnichannel ? "line-separator" : ""}`}
    >
      <footer>
        <section
          className={`gbh-footer-main-nav main-footer ${
            isOmnichannel ? "change-background-color" : ""
          }`}
          aria-label="Footer"
        >
          <section className="gbh-container">
            <div className="row">
              <div
                className="col"
                aria-label={data?.quadrantTitleOne}
                role="list"
              >
                {data?.radioNavigationOne == "descriptionOne" && (
                  <>
                    <h2>{data?.quadrantTitleOne}</h2>
                    <div
                      className="gbh-find-store"
                      role="listitem"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data?.quadrantDescOne),
                      }}
                    />
                  </>
                )}
                {data?.radioNavigationOne == "linksOne" && (
                  <>
                    {!isOmnichannel ? (
                      <div className="gbh-footer-main-nav-link">
                        <div
                          className={`footer-inner-head ${
                            gbhExpand.includes("linksOne") ? "gbh-expand" : ""
                          }`}
                          role="heading"
                          aria-level="2"
                          onClick={() => handleGbhExpand("linksOne")}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                data?.quadrantTitleOne
                              ),
                            }}
                          />
                          <div className="accordion">
                            <div className="line line-1"></div>
                            <div className="line line-2"></div>
                          </div>
                        </div>
                        <ul
                          style={
                            !gbhExpand.includes("linksOne")
                              ? { display: "none" }
                              : {}
                          }
                        >
                          {data?.items.map((item, index) => {
                            return (
                              <React.Fragment
                                key={`gbh-footer-main-nav-link-${index}`}
                              >
                                <li>
                                  <a
                                    className="gbh-data-layer"
                                    href={removeAndCleanLinkConcat(
                                      item?.brandLinkOne
                                    )}
                                    aria-label={`${item?.brandNameOne}${
                                      item?.newTabOne
                                        ? " external link opens in a new tab"
                                        : ""
                                    }`}
                                    target={`${
                                      item?.newTabOne ? "_blank" : "_self"
                                    }`}
                                    rel="noreferrer"
                                    data-gbh-data-layer={`{"clickInternalLinks":"${
                                      item?.newTabOne ? "false" : "true"
                                    }","internalLinkPosition":"${data?.quadrantTitleOne.toLowerCase()}","internalLinkZoneName":"global footer","internalLinkURL":"${getAnalyticLinkUrl(
                                      removeAndCleanLinkConcat(
                                        item?.brandLinkOne
                                      )
                                    )}","internalLinkName":"${item?.brandNameOne?.toLowerCase()}","eventName":"footer menu:${item?.brandNameOne?.toLowerCase()}","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:${item?.brandNameOne?.toLowerCase()}"}`}
                                  >
                                    {item?.brandNameOne}
                                  </a>
                                </li>
                              </React.Fragment>
                            )
                          })}
                        </ul>
                      </div>
                    ) : (
                      <div className="gbh-footer-main-nav-link">
                        <div
                          className={`footer-inner-head gbh-expand`}
                          role="heading"
                          aria-level="2"
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                data?.quadrantTitleOne
                              ),
                            }}
                          />
                        </div>
                        <ul>
                          {data?.items.map((item, index) => {
                            return (
                              <React.Fragment
                                key={`gbh-footer-main-nav-link-${index}`}
                              >
                                <li>
                                  <a
                                    className="gbh-data-layer"
                                    href={
                                      !isOmnichannel
                                        ? removeAndCleanLinkConcat(
                                            item?.brandLinkOne
                                          )
                                        : item?.brandNameOne.includes(
                                            "Whatsapp"
                                          )
                                        ? `//api.whatsapp.com/send?phone=${
                                            item?.brandNameOne.split(":")[1]
                                          }`
                                        : `tel:${
                                            item?.brandNameOne.split(":")[1]
                                          }`
                                    }
                                    // href={removeAndCleanLinkConcat(
                                    //   item?.brandLinkOne
                                    // )}
                                    aria-label={`${item?.brandNameOne}${
                                      item?.newTabOne
                                        ? " external link opens in a new tab"
                                        : ""
                                    }`}
                                    target={`${
                                      item?.newTabOne ? "_blank" : "_self"
                                    }`}
                                    rel="noreferrer"
                                    data-gbh-data-layer={`{"clickInternalLinks":"${
                                      item?.newTabOne ? "false" : "true"
                                    }","internalLinkPosition":"${data?.quadrantTitleOne.toLowerCase()}","internalLinkZoneName":"global footer","internalLinkURL":"${getAnalyticLinkUrl(
                                      removeAndCleanLinkConcat(
                                        item?.brandLinkOne
                                      )
                                    )}","internalLinkName":"${item?.brandNameOne?.toLowerCase()}","eventName":"footer menu:${item?.brandNameOne?.toLowerCase()}","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:${item?.brandNameOne?.toLowerCase()}"}`}
                                  >
                                    <span>
                                      {`${item?.brandNameOne.split(":")[0]}: `}
                                    </span>
                                    <span className="underline">
                                      {item?.brandNameOne.split(":")[1].trim()}
                                    </span>
                                  </a>
                                </li>
                              </React.Fragment>
                            )
                          })}
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </div>
              {!isOmnichannel ? (
                <div className="col" aria-label={data?.quadrantTitleTwo}>
                  {data?.radioNavigationTwo == "descriptionTwo" && (
                    <>
                      <div
                        className="footer-inner-head"
                        role="heading"
                        aria-level="2"
                      >
                        {data?.quadrantTitleTwo}
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(data?.quadrantDescTwo),
                        }}
                      />
                    </>
                  )}
                  {data.radioNavigationTwo == "linksTwo" && (
                    <>
                      <div className="gbh-footer-main-nav-link">
                        <div
                          className={`footer-inner-head ${
                            gbhExpand.includes("linksTwo") ? "gbh-expand" : ""
                          }`}
                          role="heading"
                          aria-level="2"
                          onClick={() => handleGbhExpand("linksTwo")}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                data?.quadrantTitleTwo
                              ),
                            }}
                          />
                          <div className="accordion">
                            <div className="line line-1"></div>
                            <div className="line line-2"></div>
                          </div>
                        </div>
                        <ul
                          style={
                            !gbhExpand.includes("linksTwo")
                              ? { display: "none" }
                              : {}
                          }
                          className={
                            data?.itemsOne.length > 4 ? "odd-even" : ""
                          }
                        >
                          {data?.itemsOne.map((item, index) => (
                            <li key={`linksTwo-${index}`}>
                              <a
                                className="gbh-data-layer"
                                href={removeAndCleanLinkConcat(
                                  item?.brandLinkTwo
                                )}
                                target={item?.newTabTwo ? "_blank" : ""}
                                rel="noreferrer"
                                aria-label={`${item?.brandNameTwo}${
                                  item?.newTabTwo
                                    ? " external link opens in a new tab"
                                    : ""
                                }`}
                                data-gbh-data-layer={`{"clickInternalLinks":"${
                                  item?.newTabTwo ? "false" : "true"
                                }","internalLinkPosition":"${data?.quadrantTitleTwo.toLowerCase()}","internalLinkZoneName":"global footer","internalLinkURL":"${getAnalyticLinkUrl(
                                  removeAndCleanLinkConcat(item?.brandLinkTwo)
                                )}","internalLinkName":"${item?.brandNameTwo?.toLowerCase()}", "eventName":"footer menu:${item?.brandNameTwo?.toLowerCase()}", "internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:${item?.brandNameTwo?.toLowerCase()}"}`}
                              >
                                {item?.brandNameTwo && item?.brandNameTwo}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              ) : null}
              {!isOmnichannel ? (
                <div className="col" aria-label={data?.quadrantTitleThree}>
                  {data?.descriptionThree == "descriptionThree" && (
                    <>
                      <h2>{data?.quadrantTitleThree}</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(data?.quadrantDescThree),
                        }}
                      />
                    </>
                  )}
                  {data?.radioNavigationThree == "linksThree" && (
                    <>
                      <div className="gbh-footer-main-nav-link">
                        <div
                          className={`footer-inner-head ${
                            gbhExpand.includes("linksThree") ? "gbh-expand" : ""
                          }`}
                          role="heading"
                          aria-level="2"
                          onClick={() => handleGbhExpand("linksThree")}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                data?.quadrantTitleThree
                              ),
                            }}
                          />
                          <div className="accordion">
                            <div className="line line-1"></div>
                            <div className="line line-2"></div>
                          </div>
                        </div>
                        <ul
                          style={
                            !gbhExpand.includes("linksThree")
                              ? { display: "none" }
                              : {}
                          }
                          className={
                            data?.itemsTwo.length > 4 ? "odd-even" : ""
                          }
                        >
                          {data?.itemsTwo.map((item, index) => (
                            <li key={`linksThree-${index}`}>
                              <a
                                className="gbh-data-layer"
                                href={removeAndCleanLinkConcat(
                                  item?.brandLinkThree
                                )}
                                target={item?.newTabThree ? "_blank" : ""}
                                rel="noreferrer"
                                aria-label={`${item?.brandNameThree}${
                                  item?.newTabThree
                                    ? " external link opens in a new tab"
                                    : ""
                                }`}
                                data-gbh-data-layer={`{"clickInternalLinks":"${
                                  item?.newTabThree ? "false" : "true"
                                }","internalLinkPosition":"${data?.quadrantTitleThree.toLowerCase()}","internalLinkZoneName":"global footer","internalLinkURL":"${getAnalyticLinkUrl(
                                  removeAndCleanLinkConcat(item?.brandLinkThree)
                                )}","internalLinkName":"${item?.brandNameThree?.toLowerCase()}","eventName":"footer menu:${item?.brandNameThree?.toLowerCase()}","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:${item?.brandNameThree?.toLowerCase()}"}`}
                              >
                                {item?.brandNameThree && item?.brandNameThree}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              ) : null}
              {!isOmnichannel ? (
                <div className="col" aria-label={data?.quadrantTitleFour}>
                  {data?.radioNavigationFour == "descriptionFour" && (
                    <>
                      <h2>{data?.quadrantTitleFour}</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(data?.quadrantDescFour),
                        }}
                      />
                    </>
                  )}
                  {data?.radioNavigationFour == "linksFour" && (
                    <>
                      <div className="gbh-footer-main-nav-link">
                        <div
                          className={`footer-inner-head ${
                            gbhExpand.includes("linksFour") ? "gbh-expand" : ""
                          }`}
                          role="heading"
                          aria-level="2"
                          onClick={() => handleGbhExpand("linksFour")}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                data?.quadrantTitleFour
                              ),
                            }}
                          />
                          <div className="accordion">
                            <div className="line line-1"></div>
                            <div className="line line-2"></div>
                          </div>
                        </div>
                        <ul
                          style={
                            !gbhExpand.includes("linksFour")
                              ? { display: "none" }
                              : {}
                          }
                          className={
                            data?.itemsThree.length > 4 ? "odd-even" : ""
                          }
                        >
                          {data?.itemsThree.map((item, index) => (
                            <li key={`linksThree-${index}`}>
                              <a
                                className="gbh-data-layer"
                                href={removeAndCleanLinkConcat(
                                  item?.brandLinkFour
                                )}
                                target={item?.newTabFour ? "_blank" : ""}
                                rel="noreferrer"
                                aria-label={`${item?.brandNameFour}${
                                  item?.newTabFour
                                    ? " external link opens in a new tab"
                                    : ""
                                }`}
                                data-gbh-data-layer={`{"clickInternalLinks":"${
                                  item?.newTabFour ? "false" : "true"
                                }","internalLinkPosition":"${data?.quadrantTitleFour.toLowerCase()}","internalLinkZoneName":"global footer","internalLinkURL":"${getAnalyticLinkUrl(
                                  removeAndCleanLinkConcat(item?.brandLinkFour)
                                )}","internalLinkName":"${item?.brandNameFour?.toLowerCase()}","eventName":"footer menu:${item?.brandNameFour?.toLowerCase()}","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:${item?.brandNameFour?.toLowerCase()}"}`}
                              >
                                {item?.brandNameFour && item?.brandNameFour}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              ) : null}
            </div>
          </section>
        </section>
      </footer>
    </div>
  )
}

export default MainFooter
